import { routes } from 'constants/config';
import { DATA } from '../../../constants/actionTypes';
// eslint-disable-next-line import/no-cycle
import { bulkActionsRemoveAll, bulkActionsSubmitDone } from './bulk_core';
import { hasSelectedItemsSelector } from '../../../selectors';
import request from '../../../utils/request_ajax';
import { updateDefaultViewState } from '../../content/defaultView';
import { updateDefaultViewState as eventsUpdateDefaultViewState } from '../../inPersonTraining/defaultView';

export const animatePageOnRequest = isRequestDone => {
  if (isRequestDone) {
    NProgress.done();
  } else {
    NProgress.start();
  }
  $('html, body').animate({ scrollTop: '0' }, 300);
};

/**
 * Requesting Data
 *
 * This is used to tell react that a request is in progress. This state mutation
 * will allow components like ResultsBar to say "Looking" and Data Table to
 * fade out. Note: This won't make an actual request. See dataFetch().
 */
const dataFetchRequest = () => (dispatch, getState) => {
  animatePageOnRequest(false);

  const { bulk, filter } = getState();

  if (bulk.done && !bulk.success && !bulk.inProgress) {
    dispatch(bulkActionsSubmitDone());
  }

  return dispatch({
    type: DATA.REQUEST,
    requestUrl: filter.url,
  });
};

/**
 * Recieving Data
 *
 * This state mutation will return a new data response with content, pages, and
 * meta. It will also tell react that the request has eneded.
 */
const dataFetchSuccess = response => (dispatch, getState) => {
  animatePageOnRequest(true);

  if (hasSelectedItemsSelector(getState())) {
    dispatch(bulkActionsRemoveAll());
  }

  return dispatch({
    type: DATA.SUCCESS,
    lastFetched: Date.now(),
    isFetching: false,
    success: true,
    response,
  });
};

/**
 * Data Failed
 */
const dataFetchFailure = () => {
  animatePageOnRequest(true);
  return {
    type: DATA.FAILURE,
  };
};

/**
 * Ajax Promise
 */
let requestPromise = null;

/**
 * Fetching Data form the Server
 *
 * This state mutation will send an actual request to the server with the passed
 * url. It will also handle aborting requests in progress as well as handling
 * requests error.
 *
 * forceFetch will be used for fetching new data after a bulk action is done.
 */
export const dataFetch = forceFetch => (dispatch, getState) => {
  const {
    filter: { url },
    data: { requestUrl, isFetching },
  } = getState();

  const sameRequest = url === requestUrl;

  // Aborting a connection if isFetching
  if (isFetching && !sameRequest) {
    requestPromise.abort();
  }

  if (!sameRequest || forceFetch) {
    dispatch(dataFetchRequest());

    requestPromise = request
      .get(url)
      .done(response => {
        dispatch(dataFetchSuccess(response));
      })
      .fail((xhr, textStatus, errorThrown) => {
        if (errorThrown === 'abort') return;
        dispatch(dataFetchFailure());
      });
  }
};

export const fetchTrainers = action => (dispatch, getState) => {
  request
    .get(routes.IN_PERSON_TRAINING.TRAINERS)
    .done(response => {
      dispatch({
        type: DATA.TRAINERS,
        payload: response,
      });
    })
    .fail((xhr, textStatus, errorThrown) => {
      if (errorThrown === 'abort') return;
      dispatch(dataFetchFailure());
    });
};

/**
 * Requesting the Training Event Creators and then dispatching the EVENT_CREATORS action
 */

export const fetchEventCreators = action => (dispatch, getState) => {
  request
    .get(routes.IN_PERSON_TRAINING.CREATORS)
    .done(response => {
      dispatch({
        type: DATA.EVENT_CREATORS,
        payload: response,
      });
    })
    .fail((xhr, textStatus, errorThrown) => {
      if (errorThrown === 'abort') return;
      dispatch(dataFetchFailure());
    });
};

/**
 * Dispatching An Action and Fetching Data
 */

export const dispatchActionAndFetchData = action => (dispatch, getState) => {
  dispatch(action);
  dispatch(updateDefaultViewState());
  dispatch(eventsUpdateDefaultViewState());
  return dispatch(dataFetch());
};

/**
 * Dispatching An Action
 */

export const dispatchAction = action => dispatch => dispatch(action);

/**
 * Refresh the page with current filters
 */

export const refreshData = () => (dispatch, getState) =>
  dispatch(dataFetch(true));

/**
 * Add or update the group in data.meta.groups
 */

export const setGroupInMeta = group => (dispatch, getState) => {
  const {
    data: {
      meta: { groups },
    },
  } = getState();

  const setGroup = _.extend(groups[group.id], group);

  return dispatch({
    type: DATA.GROUPS,
    meta: {
      groups: _.extend(groups, { [group.id]: setGroup }),
    },
  });
};
